import React from 'react'
import Radial from '../../Components/Radial'

const GSRadial = () => {
  return (
    <Radial />
  )
}

export default GSRadial